const routes = {
  login: '/login',
  loginCallback: '/callback/:country?',
  inbox: '/',
  profile: '/profile',
  validateEmail: '/email/validate',
};

export default routes;
